import Header from '@coreui/react/lib/Header';
import { Col, Dropdown, Row, Spin } from 'antd';
import classNames from 'classnames';
import { SIGNALR_CHANNEL } from 'config/consts';
import { APP_USER_ROUTE } from 'config/route-consts';
import { SignalRContext } from 'core/components/App/AppContext';
import { formatDateTime } from 'core/helpers/date-time';
import { buildAbsoluteLink } from 'core/helpers/string';
import { AppUser } from 'models/AppUser';
import { UserNotification } from 'models/UserNotication';
import React, { useContext } from 'react';
import { ArrowRight, Grid } from 'react-feather';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroller';
import { Link } from 'react-router-dom';
import { useGlobal } from 'reactn';
import {
  Badge,
  ButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import man from '../../../assets/img/profile.jpg';
import './DefaultHeader.scss';
import useDefaultHeader from './DefaultHeaderHook';

export interface HeaderProps {
  onToggle?: () => void;
  className?: string;
}

function DefaultHeader(props: HeaderProps) {
  const { onToggle, className } = props;
  const [translate] = useTranslation();

  const signalRContext = useContext(SignalRContext);
  const [user] = useGlobal<AppUser>('user');
  const {
    visibleNotification,
    loading,
    handleClickToNotification,
    handleToggleNotification,
    menu,
    handleClick,
    codeLanding,
    notifications,
    loadingNotification,
    handleInfiniteOnLoad,
    hasMore,
    total,
    handleReadNotification,
    handleReadAllNotification,
    unreadNotification,
    gatewayDropDown,
    visibleLanguage,
    setVisibleLanguage,
    selectedLanguage,
    handleSetLanguage,
    handleToggerGateway,
    internalValue,
    handleMouseEnter,
    handleMouseLeave,
    handleMouseLeaveAll,
    PortalPermission,
  } = useDefaultHeader(user as AppUser, signalRContext, SIGNALR_CHANNEL);

  return (
    <Spin spinning={loading}>
      <Header
        fixed
        className={classNames(
          'navbar d-flex justify-content-between page-header',
          className,
        )}
      >
        <div className="d-flex justify-content-between">
          <div className="icon-nav-bar">
            {PortalPermission && (
              <i
                className="fa fa-bars ml-4 mt-3 pl-2"
                aria-hidden="true"
                onClick={onToggle}
              />
            )}
          </div>
        </div>
        <div className="actions d-flex align-item-center">
          {/* Notification board */}
          <ButtonDropdown
            direction="left"
            isOpen={visibleNotification}
            toggle={handleToggleNotification}
          >
            <DropdownToggle className="toggle-noti button-hover pt-0 pb-0 pl-3 pr-2">
              <i className=" tio tio-notifications_outlined" />
              <Badge color="danger" className="toggle-noti-badge">
                {unreadNotification}
              </Badge>
            </DropdownToggle>
            <DropdownMenu>
              {/* <div className="title d-flex justify-content-between p-3">
                <h6 className="f-18 mb-0">{translate('general.notifications')}</h6>
                <h6 className="mb-0" onClick={handleReadAllNotification}>
                  {translate("general.readAllNotifications")}
                </h6>
              </div> */}
              <div className="title d-flex justify-content-between border-bottom">
                <DropdownItem header>
                  <h6 className="f-18 mb-0">{translate('general.notifications')}</h6>
                </DropdownItem>
                <DropdownItem onClick={handleReadAllNotification} className="text-right">
                  <h6 className="mb-0">
                    {translate('general.readAllNotifications')}
                  </h6>
                </DropdownItem>
              </div>

              {notifications && notifications.length > 0 && (
                <div
                  className="infinite-container"
                  style={{
                    height: '600px',
                    overflowY: 'auto',
                    overflowX: 'hidden',
                  }}
                >
                  <InfiniteScroll
                    initialLoad={false}
                    loadMore={handleInfiniteOnLoad}
                    hasMore={!loadingNotification && hasMore}
                    threshold={20}
                    useWindow={false}
                    pageStart={516}
                  >
                    <div className="notifications d-flex flex-column align-item-center">
                      {notifications.map((notification: UserNotification) => (
                        <NotificationItem
                          model={notification}
                          key={notification.id}
                          onClick={handleReadNotification}
                        />
                      ))}

                      {!hasMore && (
                        <div
                          className="d-flex justify-content-center p-2"
                          style={{ background: '#e8e8e8', fontSize: 12 }}
                        >
                          {translate('general.noti.showAll')}{' '}
                          <b>&nbsp;{total}&nbsp;</b>{' '}
                          {translate('general.noti.notifications')}
                        </div>
                      )}
                    </div>
                  </InfiniteScroll>
                </div>
              )}
              {loadingNotification && (
                <div
                  className="d-flex justify-content-center"
                  style={{ width: '100%' }}
                >
                  <div className="loading-container">
                    <Spin spinning={loadingNotification} />
                  </div>
                </div>
              )}
              {!notifications?.length && !loadingNotification && (
                <div className="d-flex justify-content-center">
                  <div className="no-data-item">
                    {translate('general.info.noData')}
                  </div>
                </div>
              )}
              <DropdownItem header className="footer-notification">
                <div onClick={handleClickToNotification}>
                  {translate('general.noti.showAllNotification')}
                </div>
              </DropdownItem>
            </DropdownMenu>
          </ButtonDropdown>
          <ButtonDropdown
            direction="left"
            isOpen={visibleLanguage}
            toggle={() => setVisibleLanguage(!visibleLanguage)}
          >
            <DropdownToggle className="toggle-noti button-hover pt-0 pb-0 pl-3 pr-2">
              <div className="current_lang">
                <div className="lang">
                  <i
                    className={`flag-icon flag-icon-${
                      selectedLanguage === 'en'
                        ? 'us'
                        : selectedLanguage === 'vi'
                        ? 'vn'
                        : selectedLanguage
                    }`}
                  ></i>
                  <span className="lang-txt">{selectedLanguage}</span>
                </div>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              <div className={`more_lang active`}>
                <div className="lang" onClick={() => handleSetLanguage('vi')}>
                  <i className="flag-icon flag-icon-vn"></i>
                  <span className="lang-txt">Vietnamese</span>
                </div>
                <div className="lang" onClick={() => handleSetLanguage('en')}>
                  <i className="flag-icon flag-icon-us"></i>
                  <span className="lang-txt">
                    English<span> {'(US)'}</span>
                  </span>
                </div>
              </div>
            </DropdownMenu>
          </ButtonDropdown>
          {/* Account board */}
          <Dropdown overlay={menu} trigger={['click']} className="b-r-10">
            <div className="media profile-media">
              <img
                className="b-r-10"
                src={user?.avatar ? user?.avatar : man}
                alt=""
              />
              <div className="media-body mr-2">
                <span>{user?.displayName}</span>
                <p className="mb-0 font-roboto">
                  {user?.username} <i className="middle tio-down_ui ml-2"></i>
                </p>
              </div>
            </div>
            {/* {user?.avatar && (
                <img className="mr-1 avatar" src={user?.avatar} alt="" />
              )}
              {!user?.avatar && (
                <ConfigProvider colors={["red", "green", "blue"]}>
                  <Avatar
                    maxInitials={1}
                    round={true}
                    size="22"
                    name={user?.displayName}
                  />
                </ConfigProvider>
              )} */}
          </Dropdown>
          {/* <i
            onClick={handleShowApp}
            className="pb-2 pl-2 pr-3 pt-2 float-right tio tio-menu_vs_outlined icon-port button-menu-hover"
          /> */}
          <div className="nav-menus">
            <div className="gateway-nav onhover-dropdown on-click-dropdown">
              <div className="gateway-icon mr-3" onClick={handleToggerGateway}>
                <Grid />
              </div>
              <div
                className={`gateway-dropdown ${
                  gatewayDropDown ? 'active' : ''
                }`}
                onMouseLeave={handleMouseLeaveAll}
              >
                <div className="row-title--gateway d-flex align-items-center justify-content-between">
                  <div className="pl-3">
                    <div className="">
                      {translate('general.defaultHeader.app')}
                    </div>
                  </div>
                  <div>
                    <div>
                      <a
                        className="gateway"
                        href="/"
                        onClick={handleClick(`${codeLanding}`)}
                      >
                        <div className="d-flex justify-content-end align-items-center">
                          {translate('general.defaultHeader.gateway')}
                          <ArrowRight className="mr-2 ml-2" />
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="gateway-dropdown__box">
                  <div className="full-box">
                    {user?.appUserSiteMappings?.length > 0 &&
                      user?.appUserSiteMappings?.map(
                        (item, index) =>
                          item?.enabled &&
                          item.siteId < 100 && (
                            <div
                              className="box"
                              onMouseEnter={() => handleMouseEnter(index)}
                              onMouseLeave={handleMouseLeave}
                              key={item?.siteId}
                            >
                              {/* eslint-disable-next-line */}
                              <a
                                className="d-flex align-items-center"
                                href="#"
                                onClick={handleClick(`${item?.site.code}`)}
                              >
                                <div className={item?.site.code.split('/')[1]}>
                                  <img
                                    className="icon"
                                    src={item?.site.icon}
                                    alt=""
                                    width="40"
                                    height="40"
                                  />
                                </div>
                                <div>
                                  <div className={classNames('app-text')}>
                                    <p
                                      style={internalValue(
                                        index,
                                        item?.site?.colorCode,
                                      )}
                                    >
                                      {translate('general.defaultHeader.app')}
                                    </p>
                                    <p
                                      className="app-name"
                                      style={internalValue(
                                        index,
                                        item?.site?.colorCode,
                                      )}
                                    >
                                      {' '}
                                      {translate(item?.site.name)}
                                    </p>
                                  </div>
                                </div>
                              </a>
                            </div>
                          ),
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Header>
    </Spin>
  );
}

export interface NotificationItemProps {
  model?: UserNotification;
  onClick?: (
    id: number,
    url: string,
  ) => (ev: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const NotificationItem = (props: NotificationItemProps) => {
  const { model, onClick } = props;
  const {
    contentWeb,
    time,
    unread,
    linkWebsite,
    id,
    siteId,
    engContentWeb,
  } = model;

  return (
    <DropdownItem className="mt-2">
      <Link
        to={{
          pathname: linkWebsite
            ? `${buildAbsoluteLink(linkWebsite)}`
            : APP_USER_ROUTE,
        }}
        onClick={onClick(
          id,
          linkWebsite ? `${buildAbsoluteLink(linkWebsite)}` : '#',
        )}
      >
        <div className="notification ml-1 d-flex align-items-center align-content-center pt-2 pb-2">
          {unread === true ? (
            <>
              {siteId === 2 && (
                <div className="icon-noti-dms ml-1 mr-3">
                  <i className="tio-shop_outlined" />
                </div>
              )}

              {siteId === 1 && (
                <div className="icon-noti-portal ml-1 mr-3">
                  <i className="tio-shop_outlined" />
                </div>
              )}

              {siteId === 3 && (
                <div className="icon-noti-crm ml-1 mr-3">
                  <i className="tio-shop_outlined" />
                </div>
              )}

              {siteId === 4 && (
                <div className="icon-noti-report ml-1 mr-3">
                  <i className="tio-shop_outlined" />
                </div>
              )}
              {siteId === 8 && (
                <div className="icon-noti-ppf ml-1 mr-3">
                  <i className="tio-shop_outlined" />
                </div>
              )}
              <div className="content-noti">
                <Row>
                  <Col span={24} className="mb-2">
                    <div
                      className="content-noti-ellipsis"
                      dangerouslySetInnerHTML={{
                        __html:
                          localStorage.getItem('I18N_LANGUAGE') === 'vi'
                            ? contentWeb
                            : engContentWeb,
                      }}
                    ></div>
                  </Col>
                  <Col span={24}>
                    <span>
                      <b>{formatDateTime(time)}</b>
                    </span>
                  </Col>
                </Row>
              </div>
            </>
          ) : (
            <>
              <div className="icon-noti-read ml-1 mr-3">
                <i className="tio-shop_outlined" />
              </div>
              <div className="content-noti">
                <Row>
                  <Col span={24} className="mb-2">
                    <div
                      className="content-noti-ellipsis"
                      dangerouslySetInnerHTML={{
                        __html:
                          localStorage.getItem('I18N_LANGUAGE') === 'vi'
                            ? contentWeb
                            : engContentWeb,
                      }}
                    ></div>
                  </Col>
                  <Col span={24}>
                    <span>
                      <b>{formatDateTime(time)}</b>
                    </span>
                  </Col>
                </Row>
              </div>
            </>
          )}
        </div>
      </Link>
    </DropdownItem>
  );
};

NotificationItem.defaultProps = {
  model: new UserNotification(),
};

export default DefaultHeader;
